import tools from "../../../../../../helpers/tools";
import TitreZone from "../../../../../common/CarteLead/TitreZone";
import EmailLink from "../../../../../common/CommentList/common/EmailLink/EmailLink";
import PhoneLink from "../../../../../common/CommentList/common/PhoneLink/PhoneLink";

const euros = (n) => `${tools.truenumberWithSpaces(n)} €`;
const effectif = (n) => (n === 0 || n === null || n === undefined ? "0" : tools.truenumberWithSpaces(n));

// Société d'un lead entreprise : SIRET, ville, activité, chiffre d'affaires et
// effectif de l'établissement, contact, contrats déjà chez Perceval. Le titre
// ouvre « Infos et documents » dans le panneau.
const ZoneSociete = ({ lead, ouvrir }) => {
  const etablissement = lead.establishment || {};
  const client = lead.client || {};
  const contact = lead.userCustomer;
  const localisation = etablissement.location || {};
  const ville = [localisation.postalCode, localisation.city].filter(Boolean).join(" ");
  const activite = [client.ape, client.companyActivity].filter(Boolean).join(" · ");
  const nbContrats = lead.nbPolicies || 0;

  return (
    <section className="la-zone" aria-label="Société">
      <TitreZone icone="fa-building" onglet="infos" ouvrir={ouvrir}>
        Société
      </TitreZone>
      <ul className="la-coord">
        {etablissement.siret && (
          <li>
            <span title="SIRET de l'établissement">
              <i className="fa fa-hashtag" aria-hidden="true" />
              {tools.formatFollowingPattern(etablissement.siret, [3, 3, 3, 5], " ")}
            </span>
          </li>
        )}
        {ville && (
          <li>
            <span>
              <i className="fa fa-map-marker-alt" aria-hidden="true" />
              {ville}
            </span>
          </li>
        )}
        {activite && (
          <li>
            <span className="la-coord__long" title={activite}>
              <i className="fa fa-industry" aria-hidden="true" />
              {activite}
            </span>
          </li>
        )}
      </ul>
      <div className="la-qualif">
        {typeof etablissement.turnover === "number" && (
          <span className="la-puce la-puce--contour" title="Chiffre d'affaires de l'établissement">
            CA {euros(etablissement.turnover)}
          </span>
        )}
        <span className="la-puce la-puce--contour" title="Effectif de l'établissement">
          Effectif {effectif(etablissement.workforce)}
        </span>
      </div>
      <ul className="la-coord">
        {contact && (
          <li>
            <span>
              <i className="fa fa-user" aria-hidden="true" />
              {tools.getFullName(contact)}
            </span>
          </li>
        )}
        <li>
          <PhoneLink phone={contact && contact.phone} />
        </li>
        <li>
          <EmailLink email={contact && contact.email} />
        </li>
      </ul>
      <div className="la-prime">
        {nbContrats > 0 ? (
          <>
            Déjà client : <b>{tools.truenumberWithSpaces(nbContrats)} contrat{nbContrats > 1 ? "s" : ""}</b> en cours chez Perceval
          </>
        ) : (
          "Aucun contrat en cours chez Perceval"
        )}
      </div>
    </section>
  );
};

export default ZoneSociete;
